import { FREEZE_NODE_POSITIONS, THAW_NODE_POSITIONS } from 'ContentEditorUI/redux/actions/actionTypes';
const nodePositionsFrozenReducer = (rootState = {
  nodePositionsFrozen: false
}, {
  type
}) => {
  const state = rootState.nodePositionsFrozen;
  switch (type) {
    case FREEZE_NODE_POSITIONS:
      return true;
    case THAW_NODE_POSITIONS:
      return false;
    default:
      return state;
  }
};
export default nodePositionsFrozenReducer;